import React, {useEffect, useState} from 'react';
import {Button, Image, message, Modal, Tooltip} from "antd";
import {MenuFoldOutlined, MenuUnfoldOutlined,PlusOutlined} from "@ant-design/icons";
import './index.css'
import {useDispatch, useSelector} from "react-redux";
import {getWalletInfo} from "../../api/user";
import RechargeApp from "../infoSetting/walletInfo/recharge";
import {setCurrencies,setLeftIndex} from "../../store/modules/user";
import ChatAppSetting from "../../pages/Home/Chat/setting";
//左组件
const LeftApp =(props)=>{
    const {collapsedLeft,setCollapsedLeft,homePageIndex,setHomePageIndex,themeVlue} = props
    const dispatch = useDispatch()
    var {currencies,leftIndex,allContextMeta,userInfo} = useSelector(state=>state.user)
    const [isRechargeOpen,setIsRechargeOpen] = useState(false)
    const [isChatOpen,setIsChatOpen] = useState(false)
    var chat_meta = null
    if(allContextMeta){
        chat_meta = allContextMeta.chat_meta
    }
    //切换chat场景
    const handleChangeIndex = (i)=>{
        dispatch(setLeftIndex(i.toString()))
        setTimeout(()=>{
            if(homePageIndex!==4) setHomePageIndex(4)
        },500)
    }
    const handleChatOpen = ()=>{
        if(userInfo){
            setIsChatOpen(true)
        }else{
            message.error('请先登录！')
        }
    }
    const handleChatAppOk = ()=>{
        handleChangeIndex('0')
        setIsChatOpen(false)
    }
    const handleCloseChatApp = ()=>{
        setIsChatOpen(false)
    }
    const handleCloseRechargeModel = ()=>{
        setIsRechargeOpen(false)
    }
    const handleOk = ()=>{
        getWalletInfoList()
        handleCloseRechargeModel()
    }
    const getWalletInfoList = (t)=>{
        getWalletInfo().then(res=>{
            if(res.code === 200){
                dispatch(setCurrencies(res?.data?.currencies[0]))
            }
        })
    }
    var isLoad = false
    useEffect(()=>{
        if (!isLoad) {
            isLoad = true
            if(localStorage.getItem('ai-chat-auth-id')) getWalletInfoList()
        }
    },[])
    const handleNewPage = (n)=>{
        if(n===1) window.open('https://light-word.cn','_blank')
        else if(n===2) window.open('https://light-word.cn/lifelong-progess','_blank')
    }
    const leftSvg = `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
	                        <path d="M9 3.00171V21.0017M5 3.00171H19C20.1046 3.00171 21 3.89714 21 5.00171V19.0017C21 20.1063 20.1046 21.0017 19 21.0017H5C3.89543 21.0017 3 20.1063 3 19.0017V5.00171C3 3.89714 3.89543 3.00171 5 3.00171Z" stroke="#627900" stroke-opacity="0.95" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
	                        <path d="M16.75 16.2517L13 12.5017L16.75 8.75171L17.625 9.62671L14.75 12.5017L17.625 15.3767L16.75 16.2517Z" fill="#627900" fill-opacity="0.95"/>
	                     </svg>`
    const rightSvg = `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M9 3.00171V21.0017M5 3.00171H19C20.1046 3.00171 21 3.89714 21 5.00171V19.0017C21 20.1063 20.1046 21.0017 19 21.0017H5C3.89543 21.0017 3 20.1063 3 19.0017V5.00171C3 3.89714 3.89543 3.00171 5 3.00171Z" stroke="#627900" stroke-opacity="0.95" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M15.875 12.5017L13 9.62671L13.875 8.75171L17.625 12.5017L13.875 16.2517L13 15.3767L15.875 12.5017Z" fill="#627900" fill-opacity="0.95"/>
					  </svg>`
    return (
        <>
        <div className="leftBorder">
            {
                homePageIndex===9?
                    <div>
                        <div className="leftWrap">
                            <Image style={{"display":collapsedLeft?'none':'inline-block',marginTop:'15px'}} width={80} src={require('../../assets/comm/lw-logo.png')} alt={'logo'} preview={false}/>
                            {
                                !collapsedLeft?
                                    <Tooltip placement="bottom" title={collapsedLeft?'展开':'收起'}>
                                        <div onClick={() => {
                                            setCollapsedLeft(!collapsedLeft);
                                            localStorage.setItem('ai-chat-collapsedLeft','close')
                                        }} className={'hover'}
                                             dangerouslySetInnerHTML={{__html: leftSvg}} style={{display:'inline-block',verticalAlign:'-6px',marginRight:'5px'}}></div>
                                    </Tooltip>:''
                            }
                        </div>
                        <div style={{"display":collapsedLeft?'none':'block'}} className={'leftContent'}>
                            <Image className={'llmImg'} src={require('../../assets/left/ai-chat-llm-yfk.png')} width={260} preview={false}></Image>
                        </div>
                        <div className="leftFoot" style={{"display":collapsedLeft?'none':'block'}}>
                            <div className={'left_mTitle'}>账户余额</div>
                            <div className={'left_mMoney'}>￥<span>{currencies?.balance || 0}</span></div>
                            <div className={'left_mBtn'}><span onClick={()=>setIsRechargeOpen(true)}>充值</span></div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="leftWrap" style={{"display":collapsedLeft?'none':'block'}}>
                            <Image style={{marginTop:'-20px'}} onClick={()=>handleNewPage(1)} className={'hover'}  width={80} src={require('../../assets/comm/lw-logo.png')} alt={'logo'} preview={false}/>
                            {
                                !collapsedLeft?
                                    <Tooltip placement="bottom" title={collapsedLeft?'展开':'收起'}>
                                        <div onClick={() => {
                                            setCollapsedLeft(!collapsedLeft);
                                            localStorage.setItem('ai-chat-collapsedLeft','close')
                                        }} className={'hover'}
                                             dangerouslySetInnerHTML={{__html: leftSvg}} style={{display:'inline-block',verticalAlign:'-6px',marginRight:'5px'}}></div>
                                    </Tooltip>:''
                            }

                        </div>
                        <div style={{"display":collapsedLeft?'none':'block'}} className={'leftContent'}>
                            {
                                chat_meta&&chat_meta.length>0?
                                    <div>
                                        {
                                            chat_meta.map((res,i)=>{
                                                return (
                                                    <>
                                                    {
                                                        themeVlue==='default'?
                                                        <div className={parseInt(leftIndex)===i?'chatMeta click':'chatMeta'} key={'chat-meta-map'+i} onClick={()=>handleChangeIndex(i)}>
                                                            <Image src={res.responder_avatar} width={35} height={35} preview={false}></Image>
                                                            <span>{res.context_title}</span>
                                                        </div>:
                                                        <div className={parseInt(leftIndex)===i?'chatMeta click':'chatMetaDark'} key={'chat-meta-map-d'+i} onClick={()=>handleChangeIndex(i)}>
                                                            <Image src={res.responder_avatar} width={35} height={35} preview={false}></Image>
                                                            <span>{res.context_title}</span>
                                                        </div>
                                                    }
                                                    </>
                                                )
                                            })
                                        }
                                    </div>:''
                            }
                        </div>
                        <div className="leftFoot" style={{"display":collapsedLeft?'none':'block'}}>
                            <div className={'addPage'} onClick={handleChatOpen}>
                                <PlusOutlined /> <span>新建语境</span>
                            </div>
                            <div>
                                <Image className={'hover'} onClick={()=>handleNewPage(2)} src={require('../../assets/comm/LifelongProgress.png')} width={170} preview={false}></Image>
                            </div>
                        </div>
                    </div>
            }
            <Modal footer={null} destroyOnClose={true} title="账户余额充值" open={isRechargeOpen} onCancel={handleOk} width={360}>
                <RechargeApp handleOk={handleOk} handleCloseRechargeModel={handleCloseRechargeModel} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="语境设置(新建)" open={isChatOpen} onCancel={handleCloseChatApp} width={360}>
                <ChatAppSetting isAdd={true} handleOk={handleChatAppOk} handleCloseModel={handleCloseChatApp}/>
            </Modal>
        </div>
        </>
    )
}

export default LeftApp
